import { render, staticRenderFns } from "./UserVerified.vue?vue&type=template&id=40507fb0&"
import script from "./UserVerified.vue?vue&type=script&lang=js&"
export * from "./UserVerified.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports